import {createSlice} from "@reduxjs/toolkit";

const slice = createSlice({
        name: "component.table",
        initialState: {},
        reducers: {
            operate: (state, action) => {
                state = action.payload;
                return state;
            },
            applyFilter: (state, action) => {
                state[action.payload.field_name] = action.payload.value;
                return state;
            }
        }
    })
;

export const {operate, applyFilter} = slice.actions;

export default slice.reducer;
